module.exports = __webpack_public_path__ + "static/img/mypage-navigation-menu01.fa44e0c1.svg";